/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Index_TitleInputs */

const en_meta_showcase_index_title = /** @type {(inputs: Meta_Showcase_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel Booking Engine Demo for Direct Bookings | Lindevo`)
};

const lv_meta_showcase_index_title = /** @type {(inputs: Meta_Showcase_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervāciju sistēmas demo viesnīcām Latvijā | Lindevo`)
};

/**
* | output |
* | --- |
* | "Hotel Booking Engine Demo for Direct Bookings \| Lindevo" |
*
* @param {Meta_Showcase_Index_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_index_title = /** @type {((inputs?: Meta_Showcase_Index_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Index_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_index_title(inputs)
	return en_meta_showcase_index_title(inputs)
});